import React from 'react';
import { getIn } from 'seamless-immutable';
import { useQuery } from '@apollo/client';
import { ToggleBuyTogether } from '@catalogo/service-americanas-product/src/payment/buy-together-vip.graphql';
import { withRouter } from 'react-router';
import { superCashback } from './super-cashback';
import { getPayments } from './payments';
import { getSuggestedPrice } from './suggested-price';
import { buyTogether } from './buy-together-vip';

export const withPaymentOption = Component => ({ page, currentSku, history, ...parentProps }) => {
  const { data: buyTogetherData } = useQuery(ToggleBuyTogether);
  const salesPrice = getIn(currentSku, ['offers', 'result', 0, 'salesPrice'], '');
  const offer = getIn(currentSku, ['offers', 'result', '0']);
  const { mainPayment, secondaryPayment } = getPayments(offer);
  const suggestedPrice = getSuggestedPrice(offer, mainPayment);
  const hasSuperCashback = superCashback(page, currentSku);
  const contentModalAme = hasSuperCashback && page?.components?.['modal-ame'];

  const props = {
    salesPrice,
    mainPayment,
    secondaryPayment,
    hasSuperCashback,
    contentModalAme,
    prime: getIn(offer, ['stamps', 'prime'], false),
    international: getIn(offer, ['currency'], '') === 'USD',
    buyTogether: buyTogether(buyTogetherData, salesPrice),
    primeDiscount: getIn(offer, ['bestPaymentOption', 'hasPrimeDiscount']),
    suggestedPrice,
    currentSku,
    history,
    ...parentProps,
  };

  return <Component {...props} />;
};

export default withRouter(withPaymentOption);
